module.exports = __webpack_public_path__ + "img/services_landing_pages_xs.76466eb8.png";